// Permisos RBAC de Políticas. El ítem del sidebar exige el de lectura de planes: sin la clave
// sembrada la pantalla se esconde (fail-closed), en vez de llevar a una vista que no puede leer nada.

/** Claves de permiso del dominio. `string` y no `PermissionKey`: el generado del rbac no las trae. */
export const POLICIES_PERMISSIONS = {
    read: 'loan.creditPlan.read',
} as const;

export type PoliciesPermissionKey =
    (typeof POLICIES_PERMISSIONS)[keyof typeof POLICIES_PERMISSIONS];

/**
 * Claves del tab Especiales, que es otro recurso: las políticas viven en `/store-policies` y su
 * RBAC es propio. No hay clave de publicar aparte — publicar y pausar entran por `update`.
 */
export const STORE_POLICIES_PERMISSIONS = {
    read: 'loan.storePolicy.read',
    create: 'loan.storePolicy.create',
    update: 'loan.storePolicy.update',
} as const;

export interface StorePolicyAbilities {
    canRead: boolean;
    canCreate: boolean;
    canUpdate: boolean;
}

/** Qué puede hacer el rol en el tab Especiales. Sin la clave de lectura el tab no se pinta. */
export function resolveStorePolicyAbilities(
    grantedPermissions: ReadonlySet<string>,
): StorePolicyAbilities {
    return {
        canRead: grantedPermissions.has(STORE_POLICIES_PERMISSIONS.read),
        canCreate: grantedPermissions.has(STORE_POLICIES_PERMISSIONS.create),
        canUpdate: grantedPermissions.has(STORE_POLICIES_PERMISSIONS.update),
    };
}
